import { Fragment } from "react";
import { Link, useLocation } from "react-router";
import { Drawer, Grid } from "antd";
import { EdelLogotype } from "../components/brand-logo";
import { useNav } from "../components/app-sider/nav-context";
import { GROUP_LABEL, findNav, visibleSections, type NavGroup } from "./nav";
import { useLabs } from "./flags";

/** Tek seviyeli ana menü: 10 öğe + (geliştiricide) Labs. */
export const SiderNav = () => {
  const { pathname } = useLocation();
  const [labs] = useLabs();
  const { mobileOpen, setMobileOpen } = useNav();
  const screens = Grid.useBreakpoint();
  const isMobile = screens.lg === false;

  const active = findNav(pathname)?.section.key;
  const sections = visibleSections(labs);
  const groups: NavGroup[] = ["main", "team", "labs"];

  const content = (
    <nav className="es-sider" aria-label="Ana menü">
      <Link to="/" className="es-sider__brand" aria-label="Edel · Bugün" onClick={() => setMobileOpen(false)}>
        <EdelLogotype height={26} />
        <small>Yönetim</small>
      </Link>
      <div className="es-sider__scroll">
        {groups.map((g) => {
          const items = sections.filter((s) => s.group === g);
          if (items.length === 0) return null;
          const list = items.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.key}
                to={s.tabs[0].path}
                className="es-item"
                aria-current={active === s.key ? "page" : undefined}
                onClick={() => setMobileOpen(false)}
              >
                <span className="es-item__icon" aria-hidden>
                  <Icon />
                </span>
                <span className="es-item__label">{s.label}</span>
              </Link>
            );
          });
          const label = GROUP_LABEL[g];
          if (g === "labs") {
            return (
              <div key={g} className="es-labs">
                <div className="es-group">{label}</div>
                {list}
              </div>
            );
          }
          return (
            <Fragment key={g}>
              {label && <div className="es-group">{label}</div>}
              {list}
            </Fragment>
          );
        })}
      </div>
    </nav>
  );

  if (isMobile) {
    return (
      <Drawer
        placement="left"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        width={272}
        closable={false}
        styles={{ body: { padding: 0, display: "flex" } }}
      >
        {content}
      </Drawer>
    );
  }
  return content;
};
